const inviteCoachToClaimSchool = (axiosInstance, currentClubId, schoolId, email) => {
    return axiosInstance.post(`v1/schools/invite`, {
        currentClubId,
        schoolId,
        email,
    });
};

const getSchoolById = (axiosInstance, schoolId) => {
    return axiosInstance.get(`v1/schools/${schoolId}`);
};

export {
    inviteCoachToClaimSchool,
    getSchoolById,
};
